const pageNames: Record<string, string> = {
  '/': 'Home',
  '/villas': 'Villas',
  '/amenities-experience': 'Amenities',
  '/events-weddings': 'Events & Weddings',
  '/guest-info': 'Guest Info',
  '/blog': 'Blog',
  '/contact': 'Contact',
};

export function getReturnPage(previousPage: unknown, currentPath: string) {
  const fallback = { href: '/villas', label: 'Back to Villas' };
  if (typeof previousPage !== 'string' || !previousPage.startsWith('/')) return fallback;
  try {
    const base = 'https://tokaridge.co.nz';
    const url = new URL(previousPage, base);
    if (url.origin !== base || url.pathname === currentPath) return fallback;
    const name = pageNames[url.pathname]
      ?? (url.pathname.startsWith('/blog/') ? 'Blog Post'
        : url.pathname.startsWith('/property/') ? 'Villa' : 'Previous Page');
    return { href: `${url.pathname}${url.search}${url.hash}`, label: `Back to ${name}` };
  } catch {
    return fallback;
  }
}